/**
 * Terminal App Registry
 * 
 * Maps URL app parameter to React components for terminal access.
 * Used for direct deep-linking via terminal API key authentication.
 * 
 * Usage: http://localhost:5173/?tenant=TENANT_ID&app=APP_NAME&apiKey=API_KEY
 */

import type { ComponentType } from 'react';

// Tenant 69031406f09fed7ea2d97585 (Kirchhoff)
import { CheckinPage as Kirchhoff_CheckinPage } from '../tenants/69031406f09fed7ea2d97585/CheckinPage';
import { HoflistePage as Kirchhoff_HoflistePage } from '../tenants/69031406f09fed7ea2d97585/HoflistePage';

// Tenant 68e43b18e0652b6ee86a59d6 (Pfleiderer)
import { CheckinCheckoutApp as Pfleiderer_CheckinCheckoutApp } from '../tenants/68e43b18e0652b6ee86a59d6/applications/checkin-checkout/CheckinCheckoutApp';
import { YardListPage as Pfleiderer_YardListPage } from '../tenants/68e43b18e0652b6ee86a59d6/applications/yard-list/YardListPage';

/**
 * App Registry Structure:
 * Key format: "{tenantId}:{appName}"
 * 
 * Examples:
 * - "69031406f09fed7ea2d97585:Checkin" → CheckinPage (Kirchhoff)
 * - "68e43b18e0652b6ee86a59d6:CheckinCheckout" → CheckinCheckoutApp (Pfleiderer)
 */
export const APP_REGISTRY: Record<string, ComponentType> = {
    // Tenant: 69031406f09fed7ea2d97585 (Kirchhoff)
    '69031406f09fed7ea2d97585:Checkin': Kirchhoff_CheckinPage,
    '69031406f09fed7ea2d97585:Hofliste': Kirchhoff_HoflistePage,

    // Tenant: 68e43b18e0652b6ee86a59d6 (Pfleiderer)
    '68e43b18e0652b6ee86a59d6:CheckinCheckout': Pfleiderer_CheckinCheckoutApp,
    '68e43b18e0652b6ee86a59d6:YardList': Pfleiderer_YardListPage,
};

/**
 * Get app component by tenant and app name
 */
export function getAppComponent(tenantId: string, appName: string): ComponentType | null {
    const key = `${tenantId}:${appName}`;
    return APP_REGISTRY[key] || null;
}

/**
 * Check if app exists for tenant
 */
export function hasApp(tenantId: string, appName: string): boolean {
    const key = `${tenantId}:${appName}`;
    return key in APP_REGISTRY;
}
